import React, {useContext, useEffect, useState} from "react";
import {TouchableOpacity, View, StyleSheet, Text} from "react-native";
import PtIcon from "../core/pt-icon/pt-icon";
import PtText from "../core/pt-text/pt-text";
import PtImpersonation from "./pt-impersonation-modal";
import {useNavigation} from "@react-navigation/native";
import UserContext from "../../helpers/UserContext";
import {styleVars} from "../../app-style-vars";
import {getTranslation} from "../../helpers/getTranslation";

export default function PtImpersonate(props:any) {

  const viewingAsLabel:string = props.viewingAsLabel || getTranslation('impersonation.viewing.as.label') || 'Viewing as';
  const viewAsSomeoneElseLabel:string = props.viewAsSomeoneElseLabel || getTranslation('impersonation.view.as.someone.else.label') || 'View as someone else';
  const cannotImpersonateLabel:string = props.cannotImpersonateLabel || getTranslation('impersonation.cannot.impersonate.label') || 'Cannot impersonate';

  console.log(' ------------ ----- props showModal = ', props.showModal);

  const {userData, updateUserData} = useContext(UserContext);

  const [showImpersonationModal, setShowImpersonationModal] = useState(false);
  const navigation = useNavigation();
  const pageTitle = getTranslation('impersonation.title') || 'Impersonation';

  /** if we want the modal to be initially open we pass prop showModal=true */
  useEffect(() => {
    if(props.showModal) {
      console.log('=== showImpersonationModal useEffect = ', showImpersonationModal);
      const headerOpts = {
        menuArea: `${userData.mustImpersonate && userData.impersonatingId == null ? '' : 'back'}`,
        headerTitle: pageTitle,
        headerIcons: [],
        showLogo: false,
      };
      const component = <PtImpersonation/>;
      navigation.navigate('Modal', {headerOptions:headerOpts, componentToRender:component});
    }
  },[props.showModal])

  const toggleImpersonationModal = () => {
    if(!showImpersonationModal) {
      console.log('=== showImpersonationModal IF = ', showImpersonationModal);
      const headerOpts = {
        menuArea: `${userData.mustImpersonate && userData.impersonatingId == null ? '' : 'back'}`,
        headerTitle: pageTitle,
        headerIcons: [],
        showLogo: false,
      };
      const component = <PtImpersonation/>;
      navigation.navigate('Modal', {headerOptions:headerOpts, componentToRender:component});
    } else {
      setShowImpersonationModal(!showImpersonationModal);
      console.log('=== showImpersonationModal ELSE = ', showImpersonationModal);
    }

  }

  return(
    <>
      {userData.canImpersonate ?
        <View style={[styles.impersonationContainer]}>
          <TouchableOpacity onPress={() => toggleImpersonationModal()}>
            <View style={[styles.impersonationButtonContainer]}>
              <View style={[styles.impersonationButtonContainerLeft]}>
                <View style={[styles.impersonationIconContainer]}>
                  <PtIcon iconName={`watch-on`}/>
                </View>
              </View>
              <View style={[styles.impersonationButtonContainerCenter]}>
                {userData.impersonatingId ?
                  <View style={[styles.impersonationInfoContainer]}>
                    <PtText>{`${viewingAsLabel}: `}
                      <PtText style={{fontWeight: 'bold'}}>
                        {`${userData.impersonatingName} `}
                      </PtText>
                      <PtText>
                        ({userData.impersonatingId})
                      </PtText>
                    </PtText>
                  </View>
                  :
                  <View style={[styles.impersonationInfoContainer]}>
                    <PtText>{viewAsSomeoneElseLabel}</PtText>
                  </View>
                }
              </View>
              <View style={[styles.impersonationButtonContainerRight]}>
                <View style={[styles.impersonationIconContainer]}>
                  <PtIcon iconName={`forward-right`}/>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        </View>
        :
        <View>
          <PtText>{cannotImpersonateLabel}</PtText>
        </View>
      }
    </>
  )

}

const styles=StyleSheet.create({
  impersonationContainer: {
    backgroundColor: styleVars.boschYellow90,
    padding: styleVars.rem(.25),
    width: '100%',
  },
  impersonationButtonContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignContent: "flex-start",
  },
  impersonationButtonContainerLeft: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  impersonationButtonContainerCenter: {
    flexGrow: 1,
    flexShrink: 1,
    width: '100%',
    marginHorizontal: 40,
  },
  impersonationInfoContainer: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
  },
  impersonationButtonContainerRight: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  impersonationIconContainer: {
    paddingLeft: styleVars.rem(.25),
    paddingRight: styleVars.rem(.25),
    paddingTop: styleVars.rem(.25),
    paddingBottom: styleVars.rem(.25),
  }
})
